
import * as handlebars_family from "../handlebars_family.js";
import "../feed/feed.mustache";
import "../widget/endintoview.js";
const TPL = handlebars_family.addTemplate("feed/wall",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div data-widget=\"widget/endintoview\" class=\"fw-border1 fw-background-comment\"><flexrow class=\"fw-margin-responsive\"><div style=\"width:70px;\"><span class=\"fw-avatar fw-avatar-sizeL\" style=\"background-color:#ddd;\"></span></div><flexauto><i style=\"width:70%;height:10px;background-color:#ddd;\"></i><br><i style=\"width:15%;height:10px;background-color:#ddd;\"></i></flexauto><div style=\"width:60px;text-align:center;\"><icon style=\"font-size:36px;color:#ddd\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_add_to_favorites",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":485},"end":{"line":1,"column":518}}}))
    + "</icon></div></flexrow></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"feed/feed"),depth0,{"name":"feed/feed","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasMore") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":15},"end":{"line":1,"column":555}}})) != null ? stack1 : "")
    + " ";
},"usePartial":true,"useData":true});
export default TPL;